module.exports = __webpack_public_path__ + "static/lawn-221a1364c3333dc4a4ca3c89a130c480.png";